<template>
  <div class="auth-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
};
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-color: $--app-login-bg-color;
}
</style>
